import { forwardRef } from 'react';
import classNames from 'classnames';

import IButton from './types';
import useStyles from './styles';

export function Button({
  className,
  children,
  disabled,
  href,
  target,
  variant = 'primary',
  size = 'large',
  type = 'button',
  selected = false,
  mRef,
  onClick,
  id,
  download,
}: IButton) {
  const classes = useStyles({ variant, size, selected });

  const DOM = <span className={classNames(classes.content)}>{children}</span>;

  return href ? (
    <a
      className={classNames(classes.root, className)}
      tabIndex={0}
      href={href}
      target={target}
      aria-label=""
      onClick={onClick}
      download={download}
    >
      {DOM}
    </a>
  ) : (
    <button
      className={classNames(classes.root, className)}
      tabIndex={0}
      type={type}
      aria-label=""
      onClick={onClick}
      disabled={disabled}
      ref={mRef}
      id={id}
    >
      {DOM}
    </button>
  );
}

const ButtonWithForwardedRef = forwardRef<HTMLButtonElement, IButton>((props, ref) => (
  <Button {...props} mRef={ref} />
));
ButtonWithForwardedRef.displayName = 'Button';

export default ButtonWithForwardedRef;
